import { Badge, BadgeProps } from "@mui/material";

import './index.scss';

import { styled } from '@mui/material/styles';



export const HeaderBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -3,
        top: 5,
        border: `2px solid ${theme.palette.background.paper}`,
        backgroundColor: 'hotpink',
        padding: '0 4px',
    },
}));